var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    stroke: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1125 13.9C12.2625 10.55 12.8375 8.775 12.8375 7.9375C12.8375 7.3375 12.5 7 11.9875 7C11.4875 7 11.15 7.3375 11.15 7.9375C11.15 8.775 11.7125 10.55 11.875 13.9H12.1125ZM12 16.65C12.4625 16.65 12.8 16.325 12.8 15.85C12.8 15.3875 12.4625 15.0375 12 15.0375C11.55 15.0375 11.1875 15.3875 11.1875 15.85C11.1875 16.325 11.55 16.65 12 16.65Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bdbb5c71f9de9e30f51a1cd51c6d3364.svg";
export { ForwardRef as ReactComponent };